export class HttpHeaders {
  private headers = {
    'Content-Type': 'application/json; charset=UTF-8',
  }

  public add(key: string, value: string) {
    this.headers[key] = value
  }

  public get(key: string): string {
    return this.headers[key]
  }

  public delete(key: string): void {
    delete this.headers[key]
  }

  public toObject() {
    return this.headers
  }

  public setAuthorization(token: string) {
    if (this.get('Authorization')) {
      const [type] = this.get('Authorization').split(' ')
      this.add('Authorization', `${type} ${token}`)
    } else {
      this.add('Authorization', `Bearer ${token}`)
    }
  }
}
